(() => {
  const groups = [
    ['BRAND', [['SUMMER DROP VOLUME I','/collections/summer-drop-volume-1'],['SUMMER DROP VOLUME II','/collections/summer-drop-volume-2'], ['SUMMER DROP VOLUME III','/collections/summer-drop-volume-3'],
  ['WINTER VOLUME II','/collections/new-arrivals'],["FAUJJAAN'S VISION",'/pages/our-vision'],["FAUJJAAN'S THEME",'/pages/faujjaans-theme'],['ABOUT US','/pages/about-us']]],
    ['COMMUNITY', [['BECOME AN AFFILIATE','/pages/affiliate'],['INSTAGRAM','https://www.instagram.com/faujjaan/'],['FACEBOOK','https://www.facebook.com/share/1cNEjhd9La/?mibextid=wwXIfr'],['X','https://x.com/faujjaan?s=11']]],
    ['CUSTOMER CARE', [['CONTACT US','/pages/contact'],['TRACK YOUR ORDER','https://shopify.com/95987040576/account/orders'],['REFUND POLICY','/policies/refund-policy'],['PRIVACY POLICY','/policies/privacy-policy'],['SHIPPING POLICY','/policies/shipping-policy']]]
  ];
  function hideCurrencySelector() {
    document.querySelectorAll('body *').forEach((el) => {
      const text = (el.textContent || '').trim();
      if (text !== 'INR') return;
      const style = window.getComputedStyle(el);
      if (style.position === 'fixed' || style.position === 'sticky' || el.tagName === 'BUTTON') {
        let target = el;
        for (let i = 0; i < 5 && target.parentElement; i++) {
          const p = target.parentElement;
          const ps = window.getComputedStyle(p);
          if (ps.position === 'fixed' || ps.position === 'sticky' || p.tagName === 'LOCALIZATION-FORM' || (p.className && String(p.className).toLowerCase().includes('localization'))) target = p;
          else break;
        }
        target.classList.add('faujjaan-hide-currency');
      }
    });
  }
  function getLogo() {
    const candidates = Array.from(document.querySelectorAll('#header-component .header-logo__image-container--original img, #header-component .header-logo img, #header-component img, header .header-logo img, header img'));
    return candidates.find((img) => {
      const r = img.getBoundingClientRect();
      return r.width > 10 && r.height > 5 && (img.currentSrc || img.src);
    }) || candidates[0] || null;
  }
  function build(drawer) {
    if (!drawer || drawer.dataset.faujjaanFinalMenu === 'true') return;
    drawer.dataset.faujjaanFinalMenu = 'true';
    drawer.querySelectorAll(':scope > *').forEach((el) => {
      if (!el.classList.contains('menu-drawer__close-button')) el.dataset.faujjaanNative = 'true';
    });
    const root = document.createElement('div');
    root.className = 'faujjaan-mobile-custom-menu';
    const brand = document.createElement('div');
    brand.className = 'faujjaan-mobile-brand';
    const source = getLogo();
    if (source) {
      const logo = source.cloneNode(true);
      logo.removeAttribute('loading');
      logo.removeAttribute('data-shopify-editor-block');
      logo.className = 'faujjaan-mobile-brand-logo';
      brand.appendChild(logo);
    }
    root.appendChild(brand);
    const nav = document.createElement('nav');
    nav.className = 'faujjaan-mobile-navigation';
    const list = document.createElement('div');
    list.className = 'faujjaan-mobile-groups';
    groups.forEach(([name, links]) => {
      const card = document.createElement('div');
      card.className = 'faujjaan-mobile-group';
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      summary.className = 'faujjaan-mobile-summary';
      const title = document.createElement('span'); title.className = 'faujjaan-mobile-title'; title.textContent = name;
      const plus = document.createElement('span'); plus.className = 'faujjaan-mobile-plus'; plus.textContent = '+'; plus.setAttribute('aria-hidden','true');
      summary.append(title, plus);
      const submenu = document.createElement('div'); submenu.className = 'faujjaan-mobile-submenu';
      links.forEach(([label, href]) => {
        const a = document.createElement('a');
        a.href = href;
        a.textContent = label;
        if (label === 'TRACK YOUR ORDER') {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        }
        submenu.appendChild(a);
      });
      details.append(summary, submenu); card.appendChild(details); list.appendChild(card);
    });
    const home = document.createElement('a');
    home.className = 'faujjaan-mobile-home';
    home.href = '/';
    home.textContent = 'HOME';
    nav.appendChild(home);
    nav.appendChild(list); root.appendChild(nav);
    const social = document.createElement('div'); social.className = 'faujjaan-mobile-social'; root.appendChild(social);
    const close = drawer.querySelector(':scope > .menu-drawer__close-button');
    if (close) close.after(root); else drawer.prepend(root);
    hideCurrencySelector();
  }
  function init() {
    document.querySelectorAll('#Details-menu-drawer-container > .menu-drawer, .menu-drawer').forEach((drawer) => {
      if (drawer.querySelector('.menu-drawer__menu, nav, ul')) build(drawer);
    });
    hideCurrencySelector();
  }
  function scheduleInit() {
    setTimeout(init, 80);
    setTimeout(init, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('click', scheduleInit, { passive: true });
})();